module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('VAside', {
    attrs: {
      "sidebar-menus": _vm.sidebarMenus,
      "headerHeight": "50"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48d3da32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard_manage/dashboard_detail.vue
// module id = 1403
// module chunks = 1